export function pushLoginClickEvent(
    companyOid: string,
    isCustomer: string
) {

    if (!window.gtmData) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    const event = {
        ...window.gtmData,
        event: "ndl_click_login",
        ndl_c_uid: companyOid,
        ndl_customer: isCustomer
    };

    window.dataLayer.push(event);
}